import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ChecklistQuestionsVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-config-setup-checklist-add-new-question-dialog',
  templateUrl: './config-setup-checklist-add-new-question-dialog.component.html',
  styleUrls: ['./config-setup-checklist-add-new-question-dialog.component.css']
})
export class ConfigSetupChecklistAddNewQuestionDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<ConfigSetupChecklistAddNewQuestionDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  selectedName:any;
  selectedDescription:any;
  inputValueSefetyObservation:number
  model_:ChecklistQuestionsVM;
  ngOnInit() {
    
  }

  DialogClose(){
    this.dialogRef.close(false)
  }
  sefetyobservation = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.sefetyobservation.hasError("required") ? "You must select a value" : "";
  }
  CreateQuestion(){
    if(this.inputValueSefetyObservation == undefined || this.selectedName==undefined || this.inputValueSefetyObservation <=0 || this.selectedName==""){
      return;  
      }
      else{
        let model= new ChecklistQuestionsVM()
        model.QuestionName=this.selectedName;
        model.QuestionsDescription=this.selectedDescription
        model.QuestionCategoryID=this.data.catId
        model.ObservationTypeId=this.inputValueSefetyObservation
        model.Active=true
        this._safetyConfigService.addQuestion(model).subscribe((res: any) =>{
     
      if(res){
        console.log('result', res)
        this.DialogClose();
       
      }
      });
      }
    
}
}
